export default class PuzzleLayout {
  constructor() {
    this.gridSize = null;
    this.colCount = null;
    this.rowCount = null;
    this.spotMatrix = null;
  }

  getValueFromIndex (index) {
    const c = index % this.colCount;
    const r = Math.floor(index / this.colCount);
    return this.spotMatrix[r][c];
  }

  setTileValue (index, value) {
    const col = index % this.colCount;
    const row = Math.floor(index / this.colCount);
    this.spotMatrix[row][col] = value;
  }

  reset (rowCnt, colCnt) {
    this.colCount = colCnt;
    this.rowCount = rowCnt;
    this.spotMatrix = [];
    for (let row = 0; row < this.rowCount; row++) {
      for (let col = 0; col < this.colCount; col++) {
        if (!this.spotMatrix[row]) this.spotMatrix[row] = [];
        this.spotMatrix[row][col] = -1;
      }
    }
  }
}